import { Principal } from './Principal.js';
import jwt_decode from 'jwt-decode';

export const readJWT = (token: string): Principal => {
  // TODO validate, figure out what the problem is with types
  // @ts-ignore
  return jwt_decode(token) as Principal;
};
